import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';
import { InventoryTransfer } from 'src/app/models/inventory/inventory-transfer';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { HandlerItemsSource } from 'src/app/components/shared/handler-items/handler-items.component';

@Component({
  selector: 'app-details-inventory-transfer',
  templateUrl: './details-inventory-transfer.component.html',
  styleUrls: ['./details-inventory-transfer.component.scss'],
  standalone: false
})
export class DetailsInventoryTransferComponent implements OnInit, OnDestroy {

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    { name: "Inicio", router: '/inicio' },
    { name: "Inventario", router: '/almacen/inventario' },
    { name: "Traslado de Inventario", router: '/almacen/traslados-inventario' },
    { name: "Detalle", current: true }
  ];

  public HandlerItemsSource = HandlerItemsSource;
  private urlCrudTransfer: string = `${EndpointDictionary.InventoryTransfer.CRUD_INVENTORY_TRANSFER}`;
  public urlGetItemsWarehouse: string = `${EndpointDictionary.Item.ITEM_COMBO_OUTPUT_WAREHOUSE}`;

  public transferData: Array<InputOrOutputInventory> = [];
  public historyInventoryData: HistoryInventory = new HistoryInventory();
  public view: boolean = true;

  constructor(
    public http: HttpService,
    private message: MessageService,
    public router: Router,
    private session: SessionService,
    private storage: LocalStorageService
  ) {}

  async ngOnInit() {
    let transfer = this.session.getData('inventoryTransfer');
    if (transfer && transfer.id) {
       this.view = false;
       this.historyInventoryData = transfer;
    } else {
       this.historyInventoryData = new HistoryInventory();
    }
    this.transferData = this.historyInventoryData.items || [];
  }

  ngOnDestroy() {
    this.session.setData('inventoryTransfer', null);
  }

  async saveTransfer($event: HistoryInventory) {
    this.message.openLoading("Cargando", "Guardando Traslado de Inventario");
    
    // Convert handling items generic event back to Inventory Transfer object
    let requestPayload: InventoryTransfer = {
       originWarehouseId: $event.warehouseId,
       destinationWarehouseId: $event.destinationWarehouseId,
       comment: $event.comment,
       items: $event.items.map(item => ({
         itemInventoryId: item.itemInventoryId,
         amount: item.amount,
         costItem: item.costItem,
       }))
    };
    
    try {
      let res = await this.http.postDataBody<GenericResponse>(this.urlCrudTransfer, requestPayload);
      if (res) {
        this.message.closeLoading();
        this.message.SuccessToast("Traslado guardado correctamente");
        setTimeout(() => {
          this.router.navigate(['/almacen/traslados-inventario']);
        }, 500);
      }
    } catch (e) {
      this.message.closeLoading();
    }
  }
}
